module.exports = __webpack_public_path__ + "img/C.a2013770.png";